// export default function UrlComponent({ urlElements, style }) {
//     return (
//         <div style={{
//             width: '100%',
//             overflow: 'hidden',
//             wordWrap: 'break-word',
//             overflowWrap: 'break-word'
//         }}>
//             {urlElements?.map((ele, index) => (
//                 <div 
//                     key={index} 
//                     style={style}
//                 >
//                     <span style={{ fontWeight: 500 }}>{ele.sidetext}</span>
//                     <a 
//                         href={ele.url} 
//                         style={{
//                             color: "#3B82F6",        
//                             textDecoration: "underline",
//                             wordBreak: "break-all", 
//                         }}
//                     >
//                         {ele.url}
//                     </a>
//                 </div>
//             ))}
//         </div>
//     );
// };


export default function UrlComponent({ urlElements, outerStyle, style }) {
  return (
    <table 
      role="presentation" 
      width="100%" 
      cellSpacing="0" 
      cellPadding="0"
      style={{ width: "100%" }}
    >
      <tr>
        <td
          style={{
            width: "100%",
            padding: style?.padding,
            backgroundColor: style?.backgroundColor,
            textAlign: style?.textAlign,
            fontSize: style?.fontSize,
            fontWeight: style?.fontWeight,
            textTransform: style?.textTransform,
            color: style?.color,
            wordBreak: "break-word",
            overflowWrap: "break-word",
          }}
        >
          {/* List of URL elements */}
          {urlElements?.map((ele, index) => (
            <table
              key={index}
              role="presentation"
              width="100%"
              cellSpacing="0"
              cellPadding="0"
              style={{ width: "100%", marginBottom: "6px" }}
            >
              <tr>
                <td>
                  {/* Side Text */}
                  <span style={{ fontWeight: 500 }}>
                    {ele.sidetext}
                  </span>

                  {/* URL Link */}
                  <a
                    href={ele.url}
                    style={{
                      color: "#3B82F6",
                      textDecoration: "underline",
                      wordBreak: "break-all",
                      marginLeft: "4px",
                    }}
                  >
                    {ele.url}
                  </a>
                </td>
              </tr>
            </table>
          ))}
        </td>
      </tr>
    </table>
  );
}
